module.exports = __webpack_public_path__ + "static/dental-kit-4efd35dad46f12f313b95513baac70c7.jpg";